import React, {useState} from 'react'
import {Row, Col, Button, notification, Input, Popconfirm} from 'antd'

import './ConfirmVerificationCode.scss'

function CodeInput({ handleChange }) {
  const [code, setCode] = useState(null);
  return (
    <Input
      style={{ width: 100 }}
      placeholder="Código"
      value={code}
      onChange={(e) => {
        const { value } = e.target
        const parsedValue = parseInt(value);

        if (isNaN(parsedValue)) {
          setCode(null);
          return;
        }

        if (parsedValue < 10000) {
          setCode(parsedValue);
          handleChange(value)
        }
      }}
    />
  )
}

const ConfirmVerificationCode = (callBack) => {
  const key = `open${Date.now()}`

  function ConfirmRemoveButtons() {
    const [code, setCode] = useState("")
    const [showConfirm, setShowConfirm] = useState(false)

    function finish() {
      const withCodeConfirmation = code !== ""
      callBack(code, withCodeConfirmation)
      notification.close(key)
    }

    function handleFinish() {
      if (code === "") {
        setShowConfirm(true)
        return
      }

      finish()
    }

    return (
      <Row>
        <Col span={12}>
          <CodeInput handleChange={value => setCode(value)} />
        </Col>
        <Col span={12}>
          <Row gutter={14}>
            <Col span={12}>
              <Button onClick={() => notification.close(key)}>
                Cancelar
              </Button>
            </Col>
            <Col span={12}>
              <Popconfirm
                title="Tem certeza que deseja finalizar sem verificar código?"
                visible={showConfirm}
                onConfirm={() => finish()}
                onCancel={() => setShowConfirm(false)}
              >
                <Button className="red-buttom" onClick={() => handleFinish()}>
                  Verificar
                </Button>
              </Popconfirm>
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }

  notification.open({
    message: 'Atenção',
    description: 'Para que o pedido seja finalizado com segurança, digite o código de verificação informado pelo entregador',
    btn: <ConfirmRemoveButtons />,
    className: "confirm-verification-code",
    key,
    duration: 0
  })
}

export default ConfirmVerificationCode
